import fileDownload from "js-file-download";
import { deleteRequest, getFileAccessHttpUrl } from "@/utils/api";
export const RyouTableMixins = {
    data() {
        return {
            queryParam: {},
            dataSource: [],
            selectedRowKeys: [],
            selectionRows: [],
            uploadFileUrl: '',
            uploadImgUrl: '',
            defaultTableName: 'ryouTable'
        }
    },
    mounted() {
        // this.$refs.ryouTable.$on('getSelectedRowKeys', this.getSelectedRowKeys)
        let tableName = this.getTableRef();
        if (this.$refs[tableName]) {
            this.$refs[tableName].$on('getSelectedRowKeys', this.getSelectedRowKeys)
        }
    },
    methods: {
        getTableRef() {
            if (`${this.tableName}`) {
                return `${this.tableName}`;
            } else {
                return this.defaultTableName;
            }
        },
        searchQuery(val) {
            console.log(val)
            let tableName = this.getTableRef();
            this.$refs[tableName].loadData(1);
        },
        handleDelete: function (id) {
            if (!this.url.delete) {
                this.$toast.open({
                    message: "url.delete属性を設定してください。",
                    type: "error"
                });
                return
            }
            var that = this;
            let params = {
                user_id: this.$store.getters.getUserId
            };
            this.deleteRequest(that.url.delete + "/" + id, params, this.$store.getters.getUserToken).then((res) => {
                if (res.success) {
                    that.$refs.ryouTable.loadData();
                }
            });
        },
        handleEdit: function (record) {
            this.$refs.modalForm.edit(record);
        },
        handleAdd: function () {
            this.$refs.modalForm.add();
        },
        getSelectedRowKeys(items, keys) {
            this.selectionRows = items;
            this.selectedRowKeys = keys;
            // items.forEach((item) => {
            //     this.selectedRowKeys.push(item.rowKey);
            // });
        },
        getImgView(text) {
            if (text && text.indexOf(",") > 0) {
                text = text.substring(0, text.indexOf(","))
            }
            return getFileAccessHttpUrl(text, this.uploadImgUrl);
        },
        uploadFile(text, item) {
            console.log(item)
            if (!text) {
                this.$toast.open({
                    message: "ファイルが存在しません。",
                    type: "warning"
                });
                return;
            }
            if (text.indexOf(",") > 0) {
                text = text.substring(0, text.indexOf(","));
            }

            let streamParams = {
                fileName: text,
            };

            this.getStreamRequest(this.uploadFileUrl, streamParams, this.$store.getters.getUserToken).then(res => {
                const blob = new Blob([res], { type: 'application/octet-stream;charset=utf-8' });
                return fileDownload(blob, text);
            }).catch(function (error) {
                console.log(error);
            });
        },
        batchDel: function () {
            if (!this.url.deleteBatch) {
                this.$toast.open({
                    message: "url.deleteBatch属性を設定してください。",
                    type: "error"
                });
                return
            }
            if (this.selectedRowKeys.length <= 0) {
                this.$toast.open({
                    message: "対象データが選択されていません。",
                    type: "info"
                });
                return;
            } else {
                var ids = "";
                for (var a = 0; a < this.selectedRowKeys.length; a++) {
                    ids += this.selectedRowKeys[a] + ",";
                }
                let params = {
                    user_id: this.$store.getters.getUserId,
                    ids: ids
                };
                var that = this;
                this.$refs.confirm
                    .open("削除", "削除します。宜しいですか？", { color: "blue" })
                    .then((confirm) => {
                        if (confirm) {
                            that.loading = true;
                            deleteRequest(that.url.deleteBatch, params, this.$store.getters.getUserToken).then((res) => {
                                if (res.success) {
                                    that.$refs.ryouTable.loadData();
                                    that.onClearSelected();
                                    that.$refs.ryouTable.selected = [];
                                }
                            }).finally(() => {
                                that.loading = false;
                            });
                        }

                    });
            }
        },
        onClearSelected() {
            this.selectedRowKeys = [];
            this.selectionRows = [];
        },
        modalFormOk() {
            this.$refs.ryouTable.loadData();
        }
        // doGridValidateSubmit() {
        //     this.$refs.tableForm.tableForm = true;
        //     var valid = this.$refs.tableForm.validate();
        //     if (valid) {
        //         console.log("ok")
        //     }
        // },
        // doGridAddRow() {
        //     this.$refs.ryouEditTable.doGridAddRow();
        // }
    }
}